import fetchApi from './api';
import {ApiResponse} from 'models/model';
import fetchApiBlob, { fetchApiBlobWithHeaders } from './apiBlob';

// Helper to format a Date or date-like value to local 'YYYY-MM-DD' string (no timezone shift)
function toLocalDateOnly(value: any): string | null {
    if (!value) return null;
    const d = value instanceof Date ? value : new Date(value);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
}

function serializeCourseDates<T extends Record<string, any>>(data: T) {
    return {
        ...data,
        startDate: toLocalDateOnly(data.startDate),
        endDate: toLocalDateOnly(data.endDate),
        openingDate: toLocalDateOnly(data.openingDate),
        closingDate: toLocalDateOnly(data.closingDate),
        registrationDate: toLocalDateOnly(data.registrationDate),
    } as T;
}

export const CourseCreate = async (data: any): Promise<ApiResponse> => {
    const payload = serializeCourseDates(data);
    return fetchApi<ApiResponse>('/Course/Create', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
}

export const CourseUpdate = async (data: any): Promise<ApiResponse> => {
    const payload = serializeCourseDates(data);
    return fetchApi<ApiResponse>('/Course/Update', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

export const CourseDelete = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/Delete', {
        method: 'POST',
        body: JSON.stringify({id})
    });
};

export const CourseGetPaging = async (searchPaging?: {
    pageIndex: number;
    pageSize: number;
    freeTextSearch: string;
    licenseClassId: string | null;
    startDate: string | null;
    endDate: string | null
}): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/GetPaging', {
        method: 'POST',
        body: searchPaging ? JSON.stringify(searchPaging) : '{}'
    });
};

export const CourseGetTeachingAndVehicle = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/GetTeachingAndVehicle', {
        method: 'POST',
        body: JSON.stringify({id})
    });
};

export const CourseGetTeachingVehicle = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/GetTeachingVehicle', {
        method: 'POST',
        body: JSON.stringify({id})
    });
};

export const CourseGet = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/Get', {
        method: 'POST',
        body: JSON.stringify({id})
    });
};

export const CourseGetView = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/GetView', {
        method: 'POST',
        body: JSON.stringify({id})
    });
};

export const CourseVehicleSave = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/SaveVehicle', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const CourseVehicleDelete = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/DeleteVehicle', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const CourseTeachingSave = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/SaveTeaching', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const CourseTeachingVehiclerSave = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/SaveTeachingAndVehicle', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const CourseGetList = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/GetListCourse', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const DuplicateTeachingVehicle = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/DuplicateTeachingVehicle', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const CourseTeachingDelete = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Course/DeleteTeaching', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const CourseExportGA = async (data: any): Promise<any> => {
    return fetchApiBlob('/Course/ExportGA', {
        body: JSON.stringify(data),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    });
}

export const CourseExportReport = async (data: any): Promise<any> => {
    return fetchApiBlob('/Course/ExportAll',{
        body: JSON.stringify(data),
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
                'Accept': 'application/json'
        },
    })
}

export const ExportTeachingAssignment = async (data: any): Promise<any> => {
    return fetchApiBlob('/Course/ExportTeachingAssignment',{
        body: JSON.stringify(data),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    })
}

export const ExportResultTracking = async (data: any): Promise<any> => {
    return fetchApiBlob('/Course/ExportResultTracking',{
        body: JSON.stringify(data),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    })
}

export const ExportDecision = async (data: any): Promise<{ blob: Blob; headers: Headers }> => {
    return fetchApiBlobWithHeaders('/Course/ExportDecision',{
        body: JSON.stringify(data),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    })
}